const IPAPI_BASE_URL = "https://ipapi.co";

export default {
  async getIpLocation(ip) {
    const response = await fetch(`${IPAPI_BASE_URL}/${ip}/json/`);
    const data = await response.json();

    if (data.error) {
      const reason =
        data.reason === "Reserved IP Address"
          ? `La IP ${ip} es una dirección reservada y no puede geolocalizarse.`
          : `No se pudo obtener la ubicación: ${data.reason || data.error}`;
      throw new Error(reason);
    }

    return data;
  },
};
